import React from 'react';
import { Navigate } from 'react-router-dom';
import withPermission from '../../utils/withPermission';
import permissionTypes from '../../components/atoms/permissionsGate/permissionTypes';
import ListTableTemplate from '../../components/templates/listTableTemplate/listTableTemplate';
import FormTemplate from '../../components/templates/formTemplate/formTemplate';
import FormWizardTemplate from '../../components/templates/formTemplate/formWizardTemplate';
import viewVods from '../../config/viewVods';
import viewComposeExperience from '../../config/viewComposeExperience';
import viewVoD from '../../config/viewVoD';
import viewVoDEdit from '../../config/viewVoDEdit';
import viewLives from '../../config/viewLives';
import viewLive from '../../config/viewLive';
import viewLiveEdit from '../../config/viewLiveEdit';
import viewLiveLog from '../../config/viewLiveLog';
import viewLiveApps from '../../config/viewLiveApps';
import viewLiveTemplates from '../../config/viewLiveTemplates';
import viewLiveTemplate from '../../config/viewLiveTemplate';
import viewLiveTemplateEdit from '../../config/viewLiveTemplateEdit';
import viewIngestServers from '../../config/viewIngestServers';
import viewIngestServer from '../../config/viewIngestServer';
import viewIngestServerEdit from '../../config/viewIngestServerEdit';
import viewGraphicManagerRun from '../../config/viewGraphicManagerRun';
import viewVodGraphicManagers from '../../config/viewVodGraphicManagers';
import viewVoDGraphicManagerEdit from '../../config/viewVoDGraphicManagerEdit';
import viewVoDGraphicManager from '../../config/viewVoDGraphicManager';
import viewLivesScheduled from '../../config/viewLivesScheduled';
import viewSponsor from '../../config/viewSponsor';
import viewSponsors from '../../config/viewSponsors';
import viewSponsorEdit from '../../config/viewSponsorEdit';
import viewComposeExperienceNew from '../../config/viewComposeExperienceNew';
import viewComposeExperienceEdit from '../../config/viewComposeExperienceEdit';
import routes, { getRoute } from '../../routes/route';
import viewVodTemplate from '../../config/viewVodTemplate';
import viewVoDTemplateEdit from '../../config/viewVoDTemplateEdit';
export const videoManagerRoutes = [
  {
    index: true,
    element: <Navigate to="vod" replace />,
  },

  {
    path: getRoute(routes.VOD),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_VOD],
          <ListTableTemplate configFile={viewVods} />
        ),
      },
      {
        path: ':id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_VOD],
          <FormTemplate configFile={viewVoD} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_VOD],
          <FormTemplate configFile={viewVoDEdit} />
        ),
      },
    ],
  },
  {
    path: getRoute(routes.VOD_TEMPLATE),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_VOD],
          <ListTableTemplate configFile={viewVodTemplate} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_VOD],
          <FormTemplate configFile={viewVoDTemplateEdit} />
        ),
      },
    ],
  },

  {
    path: getRoute(routes.VODGRAPHICMANAGER),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_VOD],
          <ListTableTemplate configFile={viewVodGraphicManagers} />
        ),
      },
      {
        path: ':id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_VOD],
          <FormTemplate configFile={viewVoDGraphicManager} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_VOD],
          <FormTemplate configFile={viewVoDGraphicManagerEdit} />
        ),
      },
    ],
  },

  {
    path: getRoute(routes.COMPOSE_EXPERIENCE),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_VOD],
          <ListTableTemplate configFile={viewComposeExperience} />
        ),
      },
      {
        path: ':id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_VOD],
          <FormTemplate configFile={viewComposeExperienceNew} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_VOD],
          <FormTemplate configFile={viewComposeExperienceEdit} />
        ),
      },
    ],
  },

  {
    path: getRoute(routes.LIVE_GRAPHICMANAGER_RUN),
    element: withPermission(
      [permissionTypes.ASSETS_MANAGER_LIVE],
      <FormTemplate configFile={viewGraphicManagerRun} />
    ),
  },
  {
    path: getRoute(routes.LIVE),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_LIVE],
          <ListTableTemplate configFile={viewLives} />
        ),
      },
      {
        path: ':id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_LIVE],
          <FormWizardTemplate configFile={viewLive} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_LIVE],
          <FormWizardTemplate configFile={viewLiveEdit} />
        ),
      },
      {
        path: 'log/:id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_LIVE],
          <FormTemplate configFile={viewLiveLog} />
        ),
      },
      {
        path: 'apps/:id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_LIVE],
          <FormTemplate configFile={viewLiveApps} />
        ),
      },
    ],
  },
  {
    path: getRoute(routes.LIVETEMPLATE),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_LIVE],
          <ListTableTemplate configFile={viewLiveTemplates} />
        ),
      },
      {
        path: ':id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_LIVE],
          <FormWizardTemplate configFile={viewLiveTemplate} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_LIVE],
          <FormWizardTemplate configFile={viewLiveTemplateEdit} />
        ),
      },
    ],
  },

  {
    path: getRoute(routes.INGEST_SERVER),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_LIVE],
          <ListTableTemplate configFile={viewIngestServers} />
        ),
      },
      {
        path: ':id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_LIVE],
          <FormTemplate configFile={viewIngestServer} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.ASSETS_MANAGER_LIVE],
          <FormTemplate configFile={viewIngestServerEdit} />
        ),
      },
    ],
  },

  {
    path: getRoute(routes.LIVE_SCHEDULED),
    element: withPermission(
      [permissionTypes.ASSETS_MANAGER_LIVE_SCHEDULE],
      <FormTemplate configFile={viewLivesScheduled} />
    ),
  },

  {
    path: getRoute(routes.SPONSORS),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.APP_MANAGER_SPONSOR],
          <ListTableTemplate configFile={viewSponsors} />
        ),
      },
      {
        path: ':id',
        element: withPermission(
          [permissionTypes.APP_MANAGER_SPONSOR_CREATE],
          <FormTemplate configFile={viewSponsor} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.APP_MANAGER_SPONSOR_UPDATE],
          <FormTemplate configFile={viewSponsorEdit} />
        ),
      },
    ],
  },
];